import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DiscountsItem } from "src/store/slices/item/subitems/discounts.types";

type Props = {
  items: DiscountsItem[];
  selectedItemIndex: number;
  onSelect: (i: number) => void;
};

const DiscountChips: FC<Props> = ({ items, selectedItemIndex, onSelect }) => {
  const { t } = useTranslation();
  if (items.length <= 1) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item, i) => (
        <button
          key={item.code}
          type="button"
          onClick={() => onSelect(i)}
          className={`flex min-w-24 flex-1 cursor-pointer items-baseline justify-center gap-1 rounded-sm px-4 py-3 text-base font-medium transition-colors ${
            i === selectedItemIndex
              ? "bg-background-primary text-font-inverted"
              : "bg-background-default text-font-default outline-border-subtle hover:outline-border-active hover:text-font-active outline"
          }`}
        >
          {Math.round(Number(item.discount))}
          {t("Discounts.offSuffix")}
        </button>
      ))}
    </div>
  );
};

export default DiscountChips;
